module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Syriana.9007a87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Syriana.jpg
// module id = UY0h
// module chunks = 0